export default __webpack_public_path__ + "static/media/Sanathan_Textiles_UDRHP.891daeda.pdf";